import React, { ReactNode } from 'react'

import { ProgressSpinner } from 'primereact/progressspinner'

// Progressbar tips:
// Loading time  < 1 sec: show nothing, because users cannot keep up with what happened and might feel anxious about whatever flashed on the screen.
// Loading time  1-4 sec: show a spinner, because it feels fast.
// Loading time 2-10 sec: show a looping progressbar, because showing an animated graphic on loop offers feedback that the system is working.
// Loading time > 10 sec: show a percentage progressbar, because a visual indicator that progresses towards completion puts the user at ease and increases their willingness to wait
//
// If possible include a text explanation of the process like "Loading comments ...".
// If possbile include a cancel button to stop the process so the user is in control
//
// Start the progressive animation slower and allow it to move faster as it approaches the end.
// This way you don’t risk establishing a faster expectation than the system can maintain.
// Exceeding customer expectations always creates more satisfaction than disappointing customers by delivering less than promised.
// (Note that this slow-fast recommendation only applies to wait-animations; research has shown that for surveys, progress indicators that start fast and end slow reduce drop-off rates.)
//
// Provide a general time estimate like “This might take at least a minute” or “About 3 minutes remaining”
// Instead of showing a percentage number, consider showing the number of steps like “Updating address 3 of 50.”
//
// The detailed animations like a animated logo or random quotes designed to entertain and distract the user were generally rated the fastest together with the
// skeleton loading screen. More common loading screens like a spinner or progress bar received an overall lower rating.
//
// Sometimes User want to wait a short time for example a loan-approval app that builds suspense before delivering results to avoid making customers suspicious or
// a site for delivering personalized phone-plan recommendations that slowed down its response time in order to convince users they were actually getting custom results
//
// Source 1: https://www.nngroup.com/articles/progress-indicators/
// Source 2: https://www.diva-portal.org/smash/get/diva2:1333185/FULLTEXT01.pdf
// Source 3: https://uxmovement.com/navigation/progress-bars-vs-spinners-when-to-use-which/
// Source 4: https://www.theatlantic.com/technology/archive/2017/02/why-some-apps-use-fake-progress-bars/517233/
// Source 5: https://www.chrisharrison.net/projects/progressbars/ProgBarHarrison.pdf

interface Props {
  size?: number
}

export const ProgressSpinnerTemplate: React.FC<Props> = ({
  size = 60,
  // value,
}) => {
  const sizeInPx = `${size}px`

  return (
    <div className="card flex justify-content-center">
      <ProgressSpinner
        aria-label="Loading"
        style={{ width: sizeInPx, height: sizeInPx }}
        strokeWidth="2"
        animationDuration="2s"
      />
    </div>
  )
}
